import { render, staticRenderFns } from "./tord_invoice_list_new.vue?vue&type=template&id=51750b24&scoped=true&"
import script from "./tord_invoice_list_new.vue?vue&type=script&lang=js&"
export * from "./tord_invoice_list_new.vue?vue&type=script&lang=js&"
import style0 from "./tord_invoice_list_new.vue?vue&type=style&index=0&id=51750b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51750b24",
  null
  
)

export default component.exports